import React from 'react';

/**
 * 📊 DiscoveryProgressBar
 * Visualizes the 4 stages of in-memory ESG file validation.
 * Stages: DOWNLOAD (Stream), OPEN_FILE (Parse), IDENTIFY_SCHEMA (Schema), COMPLETE (Data)
 */
export default function DiscoveryProgressBar({ currentProgress }) {
  const { stage, status, label, percent = 0 } = currentProgress;

  const stages = [
    { id: 'DOWNLOAD', label: '1. Stream' },
    { id: 'OPEN_FILE', label: '2. Parse' },
    { id: 'IDENTIFY_SCHEMA', label: '3. Schema' },
    { id: 'COMPLETE', label: '4. Data' }
  ];

  // Helper to determine step coloring
  const getStepClass = (stepId, index) => {
    const activeIndex = stages.findIndex(s => s.id === stage);
    if (status === 'FAIL' && stage === stepId) return 'bg-danger text-white';
    if (activeIndex > index || stage === 'COMPLETE') return 'bg-success text-white';
    if (stage === stepId) return 'bg-primary text-white shadow-sm';
    return 'bg-light text-muted';
  };

  return (
    <div className="discovery-progress-container p-4 border rounded bg-white shadow-sm">
      <div className="text-center mb-4">
        {/* The Spinning Halo Logic */}
        <div className={`spinner-border ${status === 'FAIL' ? 'text-danger' : 'text-primary'} mb-3`} 
             style={{ width: '3rem', height: '3rem' }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <h6 className={`fw-bold ${status === 'FAIL' ? 'text-danger' : 'text-dark'}`}>
          {label || "Initializing Discovery..."}
        </h6>
      </div>

      {/* Progress Bar */}
      <div className="progress mb-4" style={{ height: '8px' }}>
        <div 
          className={`progress-bar progress-bar-striped progress-bar-animated ${status === 'FAIL' ? 'bg-danger' : 'bg-success'}`}
          role="progressbar" 
          style={{ width: `${percent}%` }}
        ></div>
      </div>

      {/* Step Indicators */}
      <div className="row g-2">
        {stages.map((s, i) => (
          <div key={s.id} className="col-3">
            <div className={`p-2 rounded text-center extra-small fw-bold border ${getStepClass(s.id, i)}`}>
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}